
export default function FormButton({ text, action, disabled}) {
    
    return (   
        <button className={"webForm_button"} disabled={disabled} onClick={()=>{action()}}>{disabled? "טוען..." : text}</button>
    )
}
